import { createContext, useEffect, useState } from "react";
import SocialHistoryTable from "./components/socialHistoryTable"
export type contextType={
    tableData:any[],
    setTableData:(params:any)=>void
    edit:any|null;
    setEdit:(params:any)=>void
    success:boolean
    setsuccess:(params:boolean)=> void
  
 }

 export const SocialHistoryContext=createContext<contextType|null>(null)

const SocialHistoryData = () => {
    const [tableData,setTableData]=useState([])
    const [edit,setEdit]=useState<any[]|null>(null)
    const [success,setsuccess]=useState<boolean>(false)
    useEffect(()=>{
      return ()=>{
        setTableData([])
        setEdit(null)
      }
    },[])
  return (
    <SocialHistoryContext.Provider  value={{tableData,setTableData,edit,setEdit,success,setsuccess}}>
       <SocialHistoryTable/>
    </SocialHistoryContext.Provider>
  )
}

export default SocialHistoryData